// "Pending approval" marker for a staged billing-config change (see billingChangeApi.js).
// `change` is one entry of client.pending. Withdraw is offered only to who the server lets withdraw it
// (changes.withdrawChange): the requester, or the Billing Team / an admin (judged on the real caller).

import React from 'react';
import { useAuth } from '../../auth/AuthContext';

export default function PendingTag({ change, onWithdraw }) {
  const { email, isBillingTeam } = useAuth();
  if (!change) return null;
  const mine = !!email && String(change.requestedBy || '').trim().toLowerCase() === String(email).trim().toLowerCase();
  const canWithdraw = mine || !!isBillingTeam;
  return (
    <span className="br-pending-row">
      <span
        className="br-pending-tag"
        title={`${change.summary || 'Change'} — requested by ${change.requestedBy}. The Billing Team will review it.`}
      >
        <i className="fas fa-hourglass-half" /> Pending approval
      </span>
      {/* An optimistic tag (changeId null) has nothing to withdraw until the server confirms it. */}
      {onWithdraw && canWithdraw && change.changeId != null && (
        <button type="button" className="br-pending-withdraw" onClick={e => { e.stopPropagation(); onWithdraw(change); }}>
          Withdraw
        </button>
      )}
    </span>
  );
}
